import React, { useState } from 'react';
import { CopyBlock , a11yLight, github} from 'react-code-blocks';
import staticmapImg from '../images/staticmap-updated.png'

const Endpoint = ({ url, sampleRequest,sampleResponse, method, pythonCode, jsCode }) => {
  const [language, setLanguage] = useState('javascript');
  const [isCodeCollapsed, setIsCodeCollapsed] = useState(false);
  let customMessage = '';
  
  if(sampleRequest =='/api/auth/post/getToken') {
    customMessage = '(USING THE DOTENV IN NODE.JS AS FOR ILLUSTRATION PURPOSE)';
  }

  const handleLanguageChange = (newLanguage) => {
    setLanguage(newLanguage);
  };

  const handleToggleCode = () => {
    setIsCodeCollapsed(!isCodeCollapsed);
  };

  const getCodeSnippet = () => {
    if (language === 'python') {
      return pythonCode;
    } else if (language === 'javascript') {
      return jsCode;
    }
    return '';
  };

  const showstaticImg = () =>{
    if(sampleRequest.includes("getStaticImage")){
      let staticimgdv = document.createElement("DIV")
      staticimgdv.innerHTML = "<img src={staticmapImg} alt='staticmapImg' />"

      return (<img class="staticmap_Img" src={staticmapImg} alt='staticmapImg'/>)
      // document.querySelector(".om-api-box-response").append(staticimgdv)
    }
  }

  // const handleCopyToClipboard = () => {
  //   navigator.clipboard.writeText(getCodeSnippet());
  // };

  return (
    <div>
      <div className='om-api-box-header'>
        <div>{method}</div>
        <div>{url}</div>
      </div>
      <hr className='mt-3 mb-1' style={{ border: '1px solid black' }} />
      <br></br>

      <h4 className='om-search-header'>Sample Request {customMessage}</h4>
      <div className='om-api-box'>
        <div className='om-api-box-header px-3 mb-3'>
          <div>{method}</div>
          <div>{sampleRequest}</div>
        </div>

        <div className='om-api-box-request'>
          <div>
          <button className='btn-primary' onClick={() => handleLanguageChange('javascript')}>JavaScript</button>
          <button className='btn-secondary' onClick={() => handleLanguageChange('python')}>Python</button>
          </div>
          
          <button className='btn-outline-secondary' onClick={handleToggleCode}>
            {isCodeCollapsed ? (
              <span>&#9664;</span>
            ) : (
              <span>&#9660;</span>
            )}
          </button>
          {/* <button onClick={handleCopyToClipboard}>Copy</button> */}
        </div>
        {/* <h3>{language === 'javascript' ? 'JavaScript Example' : 'Python Example'}</h3> */}
        {isCodeCollapsed ? null : (
          <div className='om-api-box-content'>
          <CopyBlock
            text={getCodeSnippet()}
            language={language}
            showLineNumbers={true}
            theme={a11yLight}
            codeBlock
            // onCopy={}
          />
          </div>
        )}
      </div>

      <br></br>
      <h5 className='om-api-box-header'>Sample Response</h5>
      <div className='om-api-box'>
        <div className='om-api-box-response'>
          <CopyBlock
            text={sampleResponse}
            language={language}
            showLineNumbers={true}
            theme={github}
            codeBlock
            // onCopy={}
          />

          {showstaticImg()}
          
        </div>
      </div>
      <br></br>
    </div>
  );
};


// const Endpoint = ({ url, method, pythonCode, jsCode }) => {
//   const [language, setLanguage] = useState('python');

//   const handleLanguageChange = (newLanguage) => {
//     setLanguage(newLanguage);
//   };

//   const getCodeSnippet = () => {
//     if (language === 'python') {
//       return pythonCode;
//     } else if (language === 'javascript') {
//       return jsCode;
//     }
//     return '';
//   };

//   return (
//     <div>
//       <h2>{url}</h2>
//       <p>Method: {method}</p>
//       <div>
//         <button onClick={() => handleLanguageChange('python')}>Python</button>
//         <button onClick={() => handleLanguageChange('javascript')}>JavaScript</button>
//       </div>
//       <h3>{language === 'python' ? 'Python Example' : 'JavaScript Example'}</h3>
//       <pre>{getCodeSnippet()}</pre>
//     </div>
//   );
// };

export default Endpoint;